import Reflux from 'reflux';
import EventData from 'shared/data/Event';

let async = { asyncResult: true },
  TagFormActions = Reflux.createActions({
    updateField: {},
    submit: {},
    create: async,
    populate: {},
    clear: {},
  });

TagFormActions.create.listenAndPromise(EventData.createGlobalElementLabel);

export default TagFormActions;
